import axiosInstance from './axiosInstance';

const userService = {
  list:                    (params = {}) => axiosInstance.get('/admin/users', { params }),
  getById:                 (id)          => axiosInstance.get(`/admin/users/${id}`),
  create:                  (data)        => axiosInstance.post('/admin/users', data),
  update:                  (id, data)    => axiosInstance.put(`/admin/users/${id}`, data),
  resetPassword:           (id, data)    => axiosInstance.post(`/admin/users/${id}/reset-password`, data),
  sendVerificationEmail:   (id)          => axiosInstance.post(`/admin/users/${id}/send-verification-email`),
  changePassword:          (data)        => axiosInstance.post('/admin/users/me/change-password', data),
  remove:                  (id)          => axiosInstance.delete(`/admin/users/${id}`),
};

export default userService;

